import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MapObject from './MapObject';
import PrintPanel from './PrintPanel';
import ExportPanel from './ExportPanel';
import ReportPanel from './ReportPanel';
import LayerPanel from './LayerPanel';
import AddressPanel from './AddressResultPanel';
import ToolsPanel from './AnnotationToolsPaper';
import InfoCard from './LayerInformationCard';
import Userbar from './Userbar';
import MapFooter from './MapFooter';

import { BalanceContext } from "../context/balance-context";
import { SessionContext } from "../context/session-context";

const useStyles = makeStyles({
    root: {
        flexGrow: 1,
        background: 'white',
        color: 'white',
      },
    mapFrame: {
        display: 'flex',
        flexDirection: 'row',
      },
    bufferPanel:{
      width:20,
    },
  });

  var handleError = function (err) {
    console.log(err);
    return new Response(JSON.stringify({
      code: 400,
      message: 'Stupid network Error'
    }));
  };

  function debounce(fn, ms) {
    let timer
    return _ => {
      clearTimeout(timer)
      timer = setTimeout(_ => {
        timer = null
        fn.apply(this, arguments)
      }, ms)
    };
  }

export default function useMap(props) {
    const classes = useStyles();
    const [state, dispatch] = useContext(BalanceContext);
    const [sState, sDispatch] = useContext(SessionContext);
    const [mapHeight, setMapHeight] = useState(0);
    const [mapWidth, setMapWidth] = useState(0);
    const [isActive, setIsActive] = useState(false);
    const [hasLeftPanel, setHasLeftPanel] = useState(false);
    const [hasRightPanel, setHasRightPanel] = useState(false);
    const [leftPanelWidth, setLeftPanelWidth] = useState(0);
    const [rightPanelWidth, setRightPanelWidth] = useState(0);
    const [sidePanelHeight, setSidePanelHeight] = useState(0);
    const [displayAnnoTools, setDisplayAnnoTools] = useState('none');
    const [displayLayerInfo, setDisplayLayerInfo] = useState('none');

    const [isPrint, setIsPrint] = useState(false);
    const [isAddress, setIsAddress] = useState(false);
    const [isExport, setIsExport] = useState(false);
    const [isReport, setIsReport] = useState(false);
    const [isLayers, setIsLayers] = useState(false);

    const [isTools, setIsTools] = useState(false);
    

    /**
     * First load, set resize window listerner
    */
   useEffect(() => {
        const debouncedHandleResize = debounce(function handleResize() {
          getScreenSize();
        }, 1000)

        window.addEventListener('resize', debouncedHandleResize);

        return _ => {
          window.removeEventListener('resize', debouncedHandleResize);
        }
    })

  /**
   * Queries backend for available options -- Prints or Export.
   */
  useEffect(() => {
    const abortController = new AbortController();
    const request = {   
      addressid:sState.companyid
    };

    let mounted = true;
    (async () => {
      const res = await fetch(process.env.REACT_APP_FIND_API+'/print/get', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(request),
        signal: abortController.signal,
      }).catch(handleError);
      const data = await res.json();
      if (mounted) {
        if (data.status === "success"){
          sDispatch({
            type: "settemplates",
            payload: { 
              templates: data.template,
             }
          });

        } else {
        }
      }
      const cleanup = () => {
        mounted = false;
        abortController.abort();
      };
      return cleanup;
    })();
}, []);

    /**
    * Calculates the required screensize
    */
    const getScreenSize = () => {

        let panelW = parseInt(window.innerWidth) - 50;
        let leftPanelW = 320;
        let mapW = panelW;

        let topBarHeight = 80+20;
        if (isActive){
          topBarHeight = 130+20;
        }
        let panelH = parseInt(window.innerHeight) - parseInt(topBarHeight);
        setMapHeight(panelH);
        setSidePanelHeight(panelH);

        if (hasLeftPanel) {
            setLeftPanelWidth(leftPanelW);
            mapW = panelW - leftPanelW + 20;
        }
        else {
            setLeftPanelWidth(0);
        }
        //if (hasRightPanel) { setRightPanelWidth(200); panelW -= 272; setSidePanelHeight(panelH)} else { setRightPanelWidth(0); } //272
        setMapWidth(mapW);
    }

    useEffect(() => {
        if (sState.isActive !== isActive) setIsActive(sState.isActive);
        getScreenSize();
    },[sState.isActive, isActive]);

    useEffect(() => {

        switch (sState.caction){
            case "addressresult":
                setHasLeftPanel(true);
                setIsAddress(true);
                setIsExport(false);
                setIsReport(false);
                setIsPrint(false);
                setIsLayers(false);
            break;
            case "addressdisplay":
                setIsAddress(false);
                setHasLeftPanel(false);
            break;
            case "print":
                setHasLeftPanel(true);
                setIsPrint(true);
                setIsAddress(false);
                setIsExport(false);
                setIsReport(false);
                setIsLayers(false);
                setDisplayLayerInfo('none');
                setDisplayAnnoTools('none');
            break;
            case "endprint":
              setHasLeftPanel(false);
              setIsPrint(false);
              setIsAddress(false);
              setIsExport(false);
              setIsReport(false);
              setIsLayers(false);
            break;
            case "export":
                setHasLeftPanel(true);
                setIsExport(true);
                setIsAddress(false);
                setIsPrint(false);
                setIsReport(false);
                setDisplayAnnoTools('none');
                setDisplayLayerInfo('none');
                setIsLayers(false);
            break;
            case "endexport":
              setHasLeftPanel(false);
              setIsExport(false);
              setIsAddress(false);
              setIsPrint(false);
              setIsReport(false);
              setIsLayers(false);
            break;
            case "report":
              setHasLeftPanel(true);
              setIsReport(true);
              setIsExport(false);
              setIsAddress(false);
              setIsPrint(false);
              setDisplayAnnoTools('none');
              setDisplayLayerInfo('none');
              setIsLayers(false);
          break;
          case "endreport":
            setHasLeftPanel(false);
            setIsReport(false);
            setIsExport(false);
            setIsAddress(false);
            setIsPrint(false);
            setIsLayers(false);
          break;
          case "displaylayers":
              setHasLeftPanel(true);
              setIsAddress(false);
              setIsExport(false);
              setIsReport(false);
              setIsPrint(false);
              setIsLayers(true);
          break;
          case "displaylayerinformation":
            if (displayLayerInfo === 'none'){
              setDisplayLayerInfo('block');
            } else {
              setDisplayLayerInfo('none');
            }
          break;
          case "hidelayerinformation":
              setDisplayLayerInfo('none');
              resetUserAction();
          break;
          case "endlayers":
            setHasLeftPanel(false);
            setIsAddress(false);
            setIsExport(false);
            setIsReport(false);
            setIsPrint(false);
            setIsLayers(false);
          break;
          case "displaytools":
            if (displayAnnoTools === 'none'){
              setDisplayAnnoTools('block');
            } else {
              setDisplayAnnoTools('none');
            }
          break;
          case "endtools":
              setDisplayAnnoTools('none');
              setDisplayLayerInfo('none');
          break;
          case "logout":
            setDisplayAnnoTools('none');
            setDisplayLayerInfo('none');
            setHasLeftPanel(false);
            setIsExport(false);
            setIsReport(false);
            setIsAddress(false);
            setIsPrint(false);
            setIsLayers(false);
            break;
          case "nothing":
            // Does nothing. Used to empty action.
          case "none":
          case "getPrintPrice":
          case "addressSearch":
          case "doInfoQuery":
          case "endInfoQuery":
            // Don't reset left panel, which was causing map sizing issues
            break;
            default:
              //console.log('DEBUG: default case sState.caction', sState.caction);
              // NOTE: default case removed to avoid inconsistencies with left sidebar after unhandled actions
              //setHasLeftPanel(false);
              //setHasRightPanel(false);
          break;
        }
    },[sState.caction]);

    const resetUserAction = () => {
      sDispatch({ type: "setUserAction", payload: { action: 'nothing' } });
    }

    //Displays the info layer card (LayerInformationCard)
    useEffect(() => {
      if (sState.layerInformation.length > 0 && displayLayerInfo !== 'block'){
        setDisplayLayerInfo('block');
      }
    },[sState.layerInformation]);

    useEffect(() => {
        getScreenSize();
    },[isAddress, isPrint, isExport, isLayers]); 

    return (
        <div className={classes.root}>
            {isActive ? ( <Userbar/>) : ( '' ) }
            <div className={classes.mapFrame}>
                {isPrint ? ( <PrintPanel width={leftPanelWidth} height={sidePanelHeight}/>) : ( '' )}
                {isAddress ? ( <AddressPanel width={leftPanelWidth} height={sidePanelHeight} />) : ( '' )}
                {isExport ? ( <ExportPanel width={leftPanelWidth} height={sidePanelHeight} />) : ( '' )}
                {isReport ? ( <ReportPanel width={leftPanelWidth} height={sidePanelHeight} />) : ( '' )}
                {isLayers ? ( <LayerPanel width={leftPanelWidth} height={sidePanelHeight} />) : ( '' )}
                {!isPrint && !isExport && !isReport && !isAddress && !isLayers? ( <div className={classes.bufferPanel} />) : ( '' )}
                <MapObject active={isActive} left={leftPanelWidth} height={mapHeight} width={mapWidth} baselayer={'os10k'}/>
                <ToolsPanel display={displayAnnoTools}/>
                <InfoCard display={displayLayerInfo} leftPanelWidth={leftPanelWidth} hasLeftPanel={hasLeftPanel} />
                {!isTools ? ( <div className={classes.bufferPanel} />) : ( '' )}
            </div>
            <MapFooter />
        </div>
    )
  }
